import { QPilotAccessToken } from "../../../core/services/qpilot.service";

/**
 * Processing Cycle Interfaces
 * Matches the old QMC QPilotProcessingCycle model structure
 */

export interface ProcessingCycle {
  Id: number;
  ProcessingId?: string;
  ScheduledOrderId: number;
  CreatedUtc: Date;
  StartDateUtc: Date | null;
  EndDateUtc: Date | null;
  Total: number | null;
  ChargedTotal: number | null;
  Status: string;
  RetryCount: number;
  ProcessingErrorCode?: number | null;

  // Scheduled Order Information
  ScheduledOrderLastOccurrenceUtc?: Date | null;
  ScheduledOrderNextOccurrenceUtc?: Date | null;
  ScheduledOrderNextOccurrenceChanged?: boolean;
  ScheduledOrderFailureReason?: string | null;

  // Payment Information
  PaymentGatewayTransactionId?: string | null;
  PaymentGatewayErrorCode?: string | null;
  PaymentGatewayErrorDescription?: string | null;
  PaymentGatewayResponse?: string | null;

  // Order Information
  ClientOrderId?: string | null;
  ClientOrderCreationRequestJson?: string | null;
  ClientOrderCreationResponseJson?: string | null;
  ClientOrderUpdateRequestJson?: string | null;
  ClientOrderUpdateResponseJson?: string | null;

  // Additional fields
  Tax?: number | null;
  Shipping?: number | null;
  Discount?: number | null;
  Notes?: string | null;

  // Permissions
  CanBeEdited?: boolean;
  CanBeCompleted?: boolean;
  CanBeVoid?: boolean;
}

export interface ProcessingCycleListResponse {
  Items: ProcessingCycle[];
  TotalRecords: number;
  PageSize: number;
  Page: number;
}

export interface ScheduledOrderCyclesDialogData {
  scheduledOrderId: number;
  siteId: number;
  scheduledOrder?: import("./scheduled-orders-list-item.interface").ScheduledOrderListItem; // Full scheduled order object if available
  embeddedMode?: boolean; // Whether the dialog is opened in embedded/web component mode
  accessToken?: QPilotAccessToken; // Optional access token for embedded mode
}

/**
 * Processing Cycle Complete Request
 * Used when completing a processing cycle manually
 */
export interface ProcessingCycleCompleteRequest {
  ChargedTotal: number;
  PaymentGatewayTransactionId: string;
}

/**
 * Processing Cycle Void Request
 * Used when voiding a processing cycle
 */
export interface ProcessingCycleVoidRequest {
  VoidType: ProcessingCycleVoidType;
  Notes: string;
}

/**
 * Processing Cycle Void Type
 * Matches old QMC QPilotProcessingCycleVoidType exactly
 * Using string values to match API expectations
 */
export enum ProcessingCycleVoidType {
  VoidAndPause = "VoidAndPause",
  VoidAndSkip = "VoidAndSkip",
  VoidAndProcessNow = "VoidAndProcessNow",
  VoidAndActivate = "VoidAndActivate",
  VoidAndLeaveAsIs = "VoidAndLeaveAsIs",
}

/**
 * Processing Cycle Edit Request
 * Used when editing a processing cycle
 */
export interface ProcessingCycleEditRequest {
  ChargedTotal: number;
  Notes: string;
}
